import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SingleValue } from 'react-select';

import type { IdAdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useMarkedOptionLabel } from 'src/hooks/useMarkedOptionLabel';
import type { Option } from 'src/types';
import { useAdvertiserSelfbookingOptions } from '../hooks/useAdvertiserSelfbookingOptions';

interface AdvertiserSelfbookingFilterProps {
  value: Option<IdAdvertiserDto> | null;
  onChange: (value: SingleValue<Option<IdAdvertiserDto>>) => void;
}

export const AdvertiserSelfbookingFilter: React.FC<AdvertiserSelfbookingFilterProps> = React.memo(function AdvertiserSelfbookingFilter({
  value,
  onChange,
}) {
  const [t] = useTranslation(['backend', 'common']);
  const formatOptionLabel = useMarkedOptionLabel({ t });
  const { options, pending: loading, total, searchFilter, setSearchFilter } = useAdvertiserSelfbookingOptions();

  const handleChange = useCallbackRef((newValue: SingleValue<Option<IdAdvertiserDto>>) => {
    onChange(newValue);
  });

  return (
    <Filter<IdAdvertiserDto>
      label={t('common:ADVERTISER')}
      loading={loading}
      selected={value}
      onChange={handleChange}
      serverSideFiltering={{
        filter: searchFilter,
        setFilter: setSearchFilter,
        total,
      }}
      options={options}
      formatOptionLabel={formatOptionLabel}
      dataTestId='account-dropdown'
    />
  );
});
